<template>
  <div class="container">
    <div class="relative martch_width mt10" style="height: 30px">
      <span class="title">代理商邀请</span>
    </div>

    <van-field
     style="margin-top: 16px;"
      v-model="account"
      :error-message="error"
      required
      label="升级账号"
      placeholder=""
    />

    <div class="btn" style="margin: 16px">
      <van-button
        block
        disabled
        type="info"
        native-type="submit"
        >确认升级</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            account:'',
            error:''
        }
    },
    methods:{

    },

    mounted(){

    }
};
</script>

<style scoped>
.container {
  height: 100%;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  background: #f2f2f2;
}
.martch_width {
  width: 100%;
}
.relative {
  position: relative;
}
.column {
  display: flex;
  flex-direction: column;
}
.column_cent {
  justify-content: center;
}
.row_cent {
  align-items: center;
}
.row {
  display: flex;
  flex-direction: row;
}
.btn {
  height: 30px;
}

.mt10 {
  margin-top: 10px;
}
.back {
  position: absolute;
  left: 10px;
  width: 10px;
  height: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}
.title {
  position: absolute;
  left: 0;
  right: 0;
  color: black;
  font-size: 17px;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 30px;
}

.t1 {
  font-size: 12px;
  color: #666666;
  text-align: left;
  margin-left: 10px;
}
</style>